import React, { memo } from "react";
import { makeStyles } from "@material-ui/styles";
import TextBox from "../../box/TextBox";
import styleConstants from "../../../styleConstants";
import BrazilOutlineIcon from "../../countryIcons/BrazilOutlineIcon";
import EthiopiaOutlineIcon from "../../countryIcons/EthiopiaOutlineIcon";
import ZimbabweOutlineIcon from "../../countryIcons/ZimbabweOutlineIcon";

const useStyles = makeStyles({
  columnContainer: {
    display: "flex",
    justifyContent: "space-between"
  },
  columnDiv: {
    width: "30%",
    display: "flex",
    alignItems: "flex-start"
  },
  icon: {
    marginRight: "1rem",
    border: `2px ${styleConstants.colors.themeBlue} solid`,
    backgroundColor: styleConstants.colors.themeBluePale
  }
});

const PillSubsidiesBox = props => {
  const classes = useStyles(props);

  return (
    <TextBox
      reference="Box 3.1"
      title="Pill Subsidies from Country to Country"
      large={true}
    >
      <p>
        Using the private sector pill market as an example, the following three
        countries illustrate how the role of subsidies can vary from country to
        country:
      </p>
      <div className={classes.columnContainer}>
        <div className={classes.columnDiv}>
          <BrazilOutlineIcon width={80} height={80} className={classes.icon} />
          <p>
            <strong>Brazil</strong> has a large private sector pill market with
            no subsidized pill products present.
          </p>
        </div>
        <div className={classes.columnDiv}>
          <ZimbabweOutlineIcon
            width={80}
            height={80}
            className={classes.icon}
          />
          <p>
            <strong>Zimbabwe</strong> has a medium-sized private sector pill
            market, half of which is made up by subsidized supplies.
          </p>
        </div>
        <div className={classes.columnDiv}>
          <EthiopiaOutlineIcon
            width={80}
            height={80}
            className={classes.icon}
          />
          <p>
            <strong>Ethiopia</strong> has a small private sector pill market,
            the entirety of which is covered by subsidized supplies.
          </p>
        </div>
      </div>
    </TextBox>
  );
};

export default memo(PillSubsidiesBox);
